import { Component, Input, Output, EventEmitter, OnInit, OnDestroy, ChangeDetectorRef } from '@angular/core';
import { UntypedFormGroup } from '@angular/forms';
import { MatSelectChange } from '@angular/material/select';
import { finalize, takeUntil } from 'rxjs/operators';
import { UserUtilityService } from 'src/app/services/user-utility.service';

import { IceapiService } from '../../../../../services/index';
import { SealRingModel } from '../../../models/index';
import { Router } from '@angular/router';
import { JointCalcService } from 'src/app/Modules/idms/components/plant-manager/services/joint-calc-service.service';
import { Subject } from 'rxjs';
import { DataService } from 'src/app/services/data.service';

@Component({
    selector: 'app-seal-ring',
    templateUrl: './seal-ring.component.html',
    styleUrls: ['./seal-ring.component.scss'],
    standalone: false
})
export class SealRingComponent implements OnInit, OnDestroy {
    @Input() form: UntypedFormGroup;
    @Input() enable: boolean;
    @Input()
    set clampId(value: string) {
        this._clampId = value;
        if (!this.jointCalcService?.isPipeCode) this.getSealRings();
    }
    get clampId(): string {
        return this._clampId;
    }

    @Input()
    set pipeScheduleId(value: string) {
        this._pipeScheduleId = value;
        if (!this.jointCalcService?.isPipeCode) this.getSealRings();
    }
    get pipeScheduleId(): string {
        return this._pipeScheduleId;
    }

    @Input()
    set pipeSizeId(value: string) {
        this._pipeSizeId = value;
        if (!this.jointCalcService?.isPipeCode) this.getSealRings();
    }
    get pipeSizeId(): string {
        return this._pipeSizeId;
    }
    @Output() selected: EventEmitter<SealRingModel> = new EventEmitter();
    destroy$ = new Subject();

    tooltip_position = 'above';
    loading: boolean = false;
    optionList: SealRingModel[];
    readonly NOT_SPECIFIED: string = 'N/S';
    private _clampId: string;
    private _pipeScheduleId: string;
    private _pipeSizeId: string;

    constructor(
        private iceapi: IceapiService,
        private user_utility: UserUtilityService,
        private router: Router,
        private jointCalcService: JointCalcService,
        private dataService: DataService,
        private cd: ChangeDetectorRef,
    ) {}

    ngOnInit(): void {
        if ((this.router.url == '/idms/plantmanager' || this.router.url.includes('/idms/plantmanagerView')) && this.jointCalcService.isPipeCode) {
            this.pipespecwithsealRing();
        }
        this.form.get('sealRingNumber').valueChanges.subscribe((value) => {
            if ((this.router.url == '/idms/plantmanager' || this.router.url.includes('/idms/plantmanagerView')) && this.jointCalcService.isPipeCode) {
                this.jointCalcService.selectedsealRingId.next(value);
            }
        });
    }

    getSealRings(): void {
        if (!this.clampId || !this.pipeScheduleId || !this.pipeSizeId) return;
        this.loading = true;

        this.iceapi
            .getSealRings(this.pipeSizeId, this.pipeScheduleId, this.clampId)
            .pipe(
                finalize(() => {
                    this.loading = false;
                })
            )
            .subscribe((sealRings) => {
                if (sealRings.success === true) {
                    this.optionList = sealRings.response;
                    if (this.optionList[0].ringSize == '0') this.optionList[0].ringSize = this.NOT_SPECIFIED;
                    if (this.optionList.length === 1) {
                        this.form.get('sealRingNumber').setValue(this.optionList[0].sealRingId);
                    }
                } else {
                    this.user_utility.errorModelPopup(sealRings.message);
                }
            });
    }

    selectSealRing(selectedValue: MatSelectChange): void {
        const selection = this.optionList.find((x) => x.sealRingId === selectedValue.value);
        if (selection) {
            this.selected.emit(selection);
        }
    }

    async pipespecwithsealRing() {
        this.jointCalcService.selectedsealRingMaterial.pipe(takeUntil(this.destroy$)).subscribe(async (sl) => {
            if (sl) {
                const inputGroup = this.jointCalcService.pipeSpecpayload.lookupParams;
                inputGroup.others.boltType = null;
                inputGroup.recordId.sealRingMaterialId = sl;

                this.loading = true;
                let pipeSpecsealRing = await this.iceapi
                    .getSealRings(inputGroup.recordId.pipeSizeId, inputGroup.recordId.pipeScheduleId, inputGroup.recordId.clampId)
                    .pipe(finalize(() => {
                        this.loading = false;
                        this.cd.detectChanges();
                    }))
                    .toPromise();

                if (pipeSpecsealRing.success) {
                    this.optionList = [...pipeSpecsealRing.response];

                    this.optionList = await this.jointCalcService.managePayloadForRecourdId('sealRingId', this.optionList);
                    if (!this.optionList) {
                        this.optionList = pipeSpecsealRing.response;
                    }
                    if (this.optionList[0]?.ringSize == '0') this.optionList[0].ringSize = this.NOT_SPECIFIED;

                    if (this.dataService?.calculationData?.input?.recordId?.sealRingId)
                        this.form.get('sealRingNumber').setValue(this.dataService?.calculationData?.input?.recordId?.sealRingId);
                    else if (this.optionList.length === 1) this.form.get('sealRingNumber').setValue(this.optionList[0].sealRingId);
                } else if (pipeSpecsealRing.isCustom) {
                    this.user_utility.errorModelPopup(pipeSpecsealRing.message);
                }
            }
        });
    }

    ngOnDestroy(): void {
        this.destroy$.next(null);
        this.destroy$.complete();
    }
}
